var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "fixed w-full z-30 bg-white transition duration-300 ease-in-out border-b border-neutral-200 hover:bg-white/80 hover:backdrop-blur-sm hover:shadow-lg ",
    },
    [
      _c("div", { staticClass: "w-full px-2 lg:px-0" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between h-11 lg:h-14 lg:pr-6 pr-0",
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center mr-4 lg:pl-8 text-xl" },
              [
                _c(
                  "a",
                  {
                    staticClass: "pl-2 font-bold",
                    attrs: { "aria-label": "Cruip", href: _vm.menus[0].path },
                  },
                  [
                    _c("span", { staticClass: "hidden lg:inline" }, [
                      _vm._v("中小非标机械厂"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "relative whitespace-nowrap text-blue-600",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "absolute left-0 top-2/3 h-[0.58em] w-full fill-blue-300/70",
                            attrs: {
                              "aria-hidden": "true",
                              viewBox: "0 0 418 42",
                              preserveAspectRatio: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "relative" }, [
                          _vm._v("ERP&MES"),
                        ]),
                      ]
                    ),
                    _vm._v(" 一体化管理系统 "),
                  ]
                ),
              ]
            ),
            _vm.showMenu
              ? _c("nav", { staticClass: "hidden lg:flex lg:grow" }, [
                  _c(
                    "div",
                    { staticClass: "hidden md:flex md:gap-x-6 ml-32" },
                    _vm._l(_vm.menus, function (item, index) {
                      return _c(
                        "a",
                        {
                          key: item.key,
                          class: [
                            _vm.activeIndex === index
                              ? "bg-blue-100 text-slate-900"
                              : "",
                            "inline-block rounded-lg px-2 py-1 text-lg text-slate-700 hover:bg-blue-100 hover:text-slate-900",
                          ],
                          attrs: { href: item.path },
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "flex lg:hidden" },
              [
                _c("a-icon", {
                  attrs: { type: "menu" },
                  on: { click: _vm.showDrawer },
                }),
                _c(
                  "a-drawer",
                  {
                    attrs: { placement: "left", visible: _vm.visible },
                    on: { close: _vm.onClose },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col w-3/4" },
                      _vm._l(_vm.menus, function (item, index) {
                        return _c(
                          "a",
                          {
                            key: item.key,
                            class: [
                              _vm.activeIndex === index
                                ? "bg-blue-100 text-slate-900"
                                : "",
                              "inline-block rounded-lg px-2 py-1 text-lg text-slate-700 hover:bg-blue-100 hover:text-slate-900",
                            ],
                            attrs: { href: item.path },
                            on: { click: _vm.onClose },
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "a",
              {
                staticClass: "hidden lg:block",
                attrs: { href: "https://dev.imes.cloud", target: "_blank" },
              },
              [
                _vm.showMenu
                  ? _c("a-button", { attrs: { type: "primary" } }, [
                      _vm._v("演示登录"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "a",
              {
                staticClass: "lg:hidden",
                attrs: { href: "https://dev.imes.cloud", target: "_blank" },
              },
              [
                _vm.showMenu
                  ? _c(
                      "a-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("演示登录")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }